<template>
  <div class="pageBtmMain">
    <div class="bot_box">
      <span v-for="(item,index) in footer2" :key="index" class="one_item" @click="toNewPage(item.id)">{{ item.name }}</span>
    </div>
    <div v-if="request1" class="bot_menu_box">
      <div v-if="icp_no" class="one_menu_img" @click="openWeb('https://beian.miit.gov.cn/')">
        <img src="https://newoss.zhulong.com/edu/202012/08/32/160232ahm9yclsgkogy1tc.png" alt="">
        <span>{{ icp_no }}</span>
      </div>
      <div v-if="record_no" class="one_menu_img" @click="openWeb('http://www.beian.gov.cn/portal/registerSystemInfo')">
        <img src="https://newoss.zhulong.com/edu/202012/22/10/114510dzwggsq0ha5zgasp.png" alt="">
        <span>{{ record_no }}</span>
      </div>
    </div>
    <div v-if="request1" class="btmItem">
      <span>{{ companyName }}</span> <span v-if="companyAddress">通信地址：{{ companyAddress }}</span>
    </div>
  </div>
</template>

<script>
import { getPublic, getAgencyInfoNew } from '@/api/public'
import Cookies from 'js-cookie'
export default {
  name: 'Btm',
  data() {
    return {
      companyName: '北京金来客科技有限公司',
      companyAddress: '北京市石景山区实兴大街30号院3号楼2层D-2012',
      unipc_companyMobile: '',
      agency_id: Cookies.get('agency_id') || '',
      icp_no: '',
      record_no: '',
      footer2: [],
      request1: false
    }
  },
  created() {
  },
  mounted() {
    this.getAgencyInfo()
    this.getData2()
  },
  methods: {
    toNewPage(id) {
      const resolve = this.$router.resolve({
        path: '/footernew',
        query: { menu_id: id }
      })
      window.open(resolve.href)
    },
    openWeb(url) {
      window.open(url)
    },
    getData2() {
      const info = {
        type: 2
      }
      getPublic(info).then((res) => {
        if (res.errNo === 0) {
          const result = res.result || {}
          const bottom = result.bottom || []
          if (bottom.length > 0) {
            this.footer2 = bottom[0]
          }
        }
      })
    },
    getAgencyInfo() {
      const info = {
        agency: this.agency_id
      }
      getAgencyInfoNew(info).then((res) => {
        if (res.errNo == 0) {
          this.request1 = true
          this.icp_no = res.result.icp_no
          this.record_no = res.result.record_no
          this.companyName = res.result.name
          this.companyAddress = res.result.address
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pageBtmMain {
    margin: auto;
    width: 1200px;
    text-align: center;
    padding: 20px 0;
    line-height: 25px;
    color: #666;
    font-size: 14px;
    .trust-box {
      padding-top: 20px;
      text-align: center;
      img {
        width: 114px;
        margin-right: 20px;
      }
    }
    .bot_box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      .one_item {
        cursor: pointer;
        line-height: 30px;
        color: #666;
        font-size: 14px;
        margin: 0 5px;
      }
    }
    .btmItem {
      text-align: center;
      span {
        margin: 0 5px;
        line-height: 30px;
        color: #666;
        font-size: 14px;
      }
    }
    .bot_menu_box {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .one_menu_img {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin: 0 5px;
      }
    }
}
</style>
